export const VARIABLE_SELECTORS = {
  ARRIVAL_DATE: '{arrival_date}',
  CUTOFF_TIME: '{cutoff_time}',
  SHIPPING_RATE: '{shipping_rate}',
  SHIPPING_ZIPCODE: '{shipping_zipcode}',
};

export const DEFAULT_MESSAGES = {
  NO_EXPEDITED_SHIPPING: 'No expedited shipping options to your location',
  FREE_SHIPPING_CHECKOUT: 'Free shipping will be calculated on checkout',
  CHEAPEST_SHIPPING_PATTERN: `Cheapest shipping arrives ${VARIABLE_SELECTORS.ARRIVAL_DATE}`,
};

export const DEFAULT_ICONS = {
  DELIVERY_PARCEL: 'https://ecommerce-plugin.pdqdev.link/icons/delivery-parcel.svg',
};
